import * as React from "react";
import { useMemo } from "react";
import TableTemplate from "../../common/TableTemplate";
import { generateDynamicColumns } from "../../../utils/generateDynamicColumns";
import ModalLoadingState from "../../states/ModalLoadingState";
import ErrorState from "../../states/ErrorState";
import { useGetVariantCostDetailsQuery } from "../../../services/product";
import { columnHelper } from "../../../utils/utils";
import { Dialog, DialogContent, DialogTitle } from "../../ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

export function CostsModal({ isOpen, onClose, variantGlid }) {
  const {
    data: currentVariantCosts,
    isLoading,
    isFetching,
    error,
    isError,
  } = useGetVariantCostDetailsQuery(
    {
      page: "Variant.Cost",
      glid: variantGlid,
    },
    {
      skip: !isOpen || !variantGlid,
      refetchOnMountOrArgChange: true,
    }
  );

  const columns = useMemo(() => {
    // if (currentVariantCosts?.[0]?.Column_header) {
    return generateDynamicColumns({
      calledBy: "costs",
      columnHelper,
      headerData: currentVariantCosts?.[0]?.Column_header,
    });
    // }
    // return [];
  }, [currentVariantCosts]);

  if (isError) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent>
          <ErrorState error={error?.message || "An error occurred"} />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[98vw] max-w-[98vw] sm:w-[95vw] sm:max-w-[90vw] lg:max-w-[85vw] xl:max-w-[80vw] max-h-[90vh] p-0 gap-0 flex flex-col">
        {/* This makes the title visible to screen readers but not visible to the user, good for accessibility */}
        <VisuallyHidden>
          <DialogTitle>All Costs for this Variant</DialogTitle>
        </VisuallyHidden>

        {/* <div className="flex-1 overflow-hidden flex flex-col min-h-0"> */}
        <div className="p-2 sm:p-3 md:p-4 lg:p-6 overflow-y-auto">
          {isLoading || isFetching ? (
            <ModalLoadingState />
          ) : currentVariantCosts ? (
            <div className="h-full">
              <TableTemplate
                columns={columns}
                data={currentVariantCosts[0]?.data}
                options={{
                  defaultPageSize:
                    typeof window !== "undefined" && window.innerWidth < 640
                      ? 5
                      : 15,
                  enableColumnFilters: true,
                  enableColumnOrder: true,
                  enableColumnResize: true,
                  enableColumnVisibility: true,
                  enableGlobalFilter: true,
                  enablePagination: true,
                  enableSorting: true,
                  showPreferences: true,
                  showTotalItems: true,
                }}
                tableClassName="w-full table-auto border-collapse border-spacing-0"
                containerClassName="overflow-auto max-h-[50vh] sm:max-h-[60vh]"
              />
            </div>
          ) : (
            <div className="text-center py-4 sm:py-8 text-gray-600 flex items-center justify-center flex-1">
              <div className="px-4">
                <p className="text-sm sm:text-base lg:text-lg font-medium mb-1 sm:mb-2">
                  No costs data available
                </p>
                <p className="text-xs sm:text-sm text-gray-500">
                  There are no cost records for this variant.
                </p>
              </div>
            </div>
          )}
        </div>
        {/* </div> */}

        <div className="flex-shrink-0 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 p-2 sm:p-3 md:p-4 lg:p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Done
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
